// Export de séries temporais para CSV, partilhado entre a monitorização e as gravações.
// Separador ';' e BOM UTF-8: abre bem no Excel em português.
export function downloadReadingsAsCsv(rows: { date: string; [key: string]: any }[], columns: string[], filename: string) {
  if (!rows.length) return;
  const header = ['date', ...columns].join(';');
  const lines = rows.map(row => [row.date, ...columns.map(c => (row[c] ?? ''))].join(';'));
  const blob = new Blob(['﻿' + [header, ...lines].join('\n')], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename.replace(/[^\w\-]+/g, '_') + '.csv';
  a.click();
  URL.revokeObjectURL(a.href);
}
